//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PullTo from 'vue-pull-to'
import {getFinanceTransaction} from '@/api/user'
import {formatTime} from '@/utils/index'

export default {
  data () {
    return {
      historyItems: {},
      page: 1
    }
  },
  components: {
    PullTo
  },
  methods: {
    getHistory (isNew) {
      if (isNew === 'new') {
        this.page++
      } else {
        this.page = 1
      }
      getFinanceTransaction(this.page).then(resp => {
        const historyItems = resp.data.map(item => {
          const createAt = formatTime(item.created_at)
          return {
            createAt,
            ...item
          }
        })
        if (isNew === 'new') {
          this.historyItems = this.historyItems.concat(historyItems)
        } else {
          this.historyItems = historyItems
        }
      })
    }
  },
  mounted () {
    this.getHistory()
  }
  // onReachBottom () {
  //   this.getHistory('new');
  // }

}



// WEBPACK FOOTER //
// ./src/pages/rechargeHistory/index.vue